import {
  Typography,
  OutlinedInput,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const OrderInformation = () => {
  const { control, setValue, watch, getValues } = useFormContext();

  const renderInputField = (
    label: string,
    name: "ShopName" | "AccountName" | "OrderNo" | "PONumber",
    placeholder: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
        <>
          <OutlinedInput
            {...field}
            placeholder={placeholder}
            fullWidth
            autoComplete="off"
            disabled
            value={field.value || ""}
            sx={{ height: "40px", fontSize: "14px", borderColor: error ? "red" : undefined}}
          />
          </>
        )}
      />
    </>
  );

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Order No", "OrderNo", "Enter Order Number")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Shop Name", "ShopName", "Enter Shop Name")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Account", "AccountName", "Enter Account Name")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("PO Number", "PONumber", "Enter PO Number")}
      </Grid>
    </Grid>
  );
};

export default OrderInformation;
